module.exports = __webpack_public_path__ + "img/Default-M-1.0de2a5d5.svg";